import { DownloadOutlined } from '@ant-design/icons';
import { Button, Checkbox, Col, Input, Row, Select } from 'antd';
import { RoleFilter } from '../userList.types';
import { roleFilterOptions } from '../userList.utils';

interface UserListToolbarProps {
  exportContractsLoading: boolean;
  onAddEmployee: () => void;
  onExportContracts: () => void | Promise<void>;
  onRoleFilterChange: (role: RoleFilter) => void;
  onSearchChange: (value: string) => void;
  onShowInactiveUsersChange: (checked: boolean) => void;
  onUploadContracts: () => void;
  onUploadEmployees: () => void;
  onUploadPhotos: () => void;
  roleFilter: RoleFilter;
  searchValue: string;
  showInactiveUsers: boolean;
}

export const UserListToolbar = ({
  exportContractsLoading,
  onAddEmployee,
  onExportContracts,
  onRoleFilterChange,
  onSearchChange,
  onShowInactiveUsersChange,
  onUploadContracts,
  onUploadEmployees,
  onUploadPhotos,
  roleFilter,
  searchValue,
  showInactiveUsers,
}: UserListToolbarProps) => (
  <>
    <Row
      align="top"
      justify="space-between"
      gutter={[16, 12]}
      className="my-5 employees-list-toolbar"
    >
      <Col flex="1 1 420px" className="search-wrapper">
        <label htmlFor="search-employees">Búsqueda:</label>
        <Input
          id="search-employees"
          data-cy="search-employees"
          type="text"
          value={searchValue}
          onChange={(event) => onSearchChange(event.target.value)}
          className="input-search"
        />
      </Col>
      <Col flex="0 1 auto" className="employees-list-actions">
        <Button
          type="primary"
          onClick={onUploadPhotos}
          id="uploadProfilePhotosBtn"
        >
          Subir fotos de perfil
        </Button>
        <Button
          type="primary"
          onClick={onUploadEmployees}
          id="uploadEmployeesBtn"
        >
          Subir empleados
        </Button>
        <Button type="primary" onClick={onUploadContracts}>
          Subir contratos
        </Button>
        <Button
          type="primary"
          onClick={() => void onExportContracts()}
          data-cy="download-contracts-template-btn"
          loading={exportContractsLoading}
          icon={<DownloadOutlined />}
        >
          Descargar contratos
        </Button>
        <Button
          type="primary"
          onClick={onAddEmployee}
          data-cy="new-employee-btn"
        >
          Agregar empleado
        </Button>
      </Col>
    </Row>
    <Row justify="end" align="middle" gutter={[16, 12]}>
      <Col className="role-filter-wrapper">
        <label htmlFor="employee-role-filter">Rol:</label>
        <Select<RoleFilter>
          id="employee-role-filter"
          data-cy="employee-role-filter"
          value={roleFilter}
          options={roleFilterOptions}
          onChange={onRoleFilterChange}
        />
      </Col>
      <Col>
        <Checkbox
          data-cy="showInactive"
          checked={showInactiveUsers}
          onChange={(event) => onShowInactiveUsersChange(event.target.checked)}
        >
          Mostrar Inactivos
        </Checkbox>
      </Col>
    </Row>
  </>
);
